<ion-header [translucent]="false" class="ion-no-border custom-header" mode="md">
  <ion-toolbar>
    <ion-title class="modal-title">{{'filter' | translate}}</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="cancel()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" class="ion-padding">
  <div class="configuration-container">
    <!-- REGION -->
    <!-- <div class="select-group">
      <label class="select-label">{{ 'region' | translate }}</label>
      <ion-select
        [(ngModel)]="filter.regionId"
        (ionChange)="onFilterChange()"
        interface="popover"
        class="styled-select"
        cssClass="select-popover">
        <ion-select-option
          *ngFor="let r of options.regions"
          [value]="r.id">
          {{ r.name | translate }}
        </ion-select-option>
      </ion-select>
    </div> -->

    <!-- CATEGORY -->
    <div class="select-group">
      <label class="select-label">{{ 'filter_category' | translate }}</label>
      <ion-select
        [(ngModel)]="filter.category"
        (ionChange)="onFilterChange()"
        interface="popover"
        class="styled-select"
        cssClass="select-popover">
        <ion-select-option [value]="null">{{ 'all' | translate }}</ion-select-option>
        <ion-select-option *ngFor="let cat of options.categories" [value]="cat">
          {{ cat | translate }}
        </ion-select-option>
      </ion-select>
    </div>

    <!-- STRUCTURE -->
    <div class="select-group">
      <label class="select-label">{{ 'filter_structure' | translate }}</label>
      <ion-select
        [(ngModel)]="filter.structure"
        (ionChange)="onFilterChange()"
        interface="popover"
        class="styled-select"
        cssClass="select-popover">
        <ion-select-option [value]="null">{{ 'all' | translate }}</ion-select-option>
        <ion-select-option *ngFor="let s of options.structures" [value]="s">
          {{ s }}
        </ion-select-option>
      </ion-select>
    </div>

    <!-- UG VALUE -->
    <div class="select-group">
      <label class="select-label">{{ 'HEADER_FILTER_UG' | translate }} (W/m².K)</label>
      <ion-select
        [(ngModel)]="filter.ug"
        (ionChange)="onFilterChange()"
        interface="popover"
        class="styled-select"
        cssClass="select-popover">
        <ion-select-option [value]="null">{{ 'all' | translate }}</ion-select-option>
        <ion-select-option *ngFor="let u of options.ugValues" [value]="u">
          {{ u.toFixed(1) }}
        </ion-select-option>
      </ion-select>
    </div>

    <!-- LIGHT TRANSMITTANCE -->
    <div class="select-group">
      <label class="select-label">{{ 'filter_light_trans' | translate }} (%)</label>
      <ion-select
        [(ngModel)]="filter.lightTransmittance"
        (ionChange)="onFilterChange()"
        interface="popover"
        class="styled-select"
        cssClass="select-popover">
        <ion-select-option [value]="null">{{ 'all' | translate }}</ion-select-option>
        <ion-select-option *ngFor="let lt of options.lightTransValues" [value]="lt">
          {{ lt }}
        </ion-select-option>
      </ion-select>
    </div>

    <!-- G-VALUE -->
    <div class="select-group">
      <label class="select-label">{{ 'filter_g_value' | translate }} (%)</label>
      <ion-select
        [(ngModel)]="filter.gValue"
        (ionChange)="onFilterChange()"
        interface="popover"
        class="styled-select"
        cssClass="select-popover">
        <ion-select-option [value]="null">{{ 'all' | translate }}</ion-select-option>
        <ion-select-option *ngFor="let g of options.gValues" [value]="g">
          {{ g }}%
        </ion-select-option>
      </ion-select>
    </div>
  </div>
</ion-content>

<ion-footer [translucent]="false" class="ion-no-border">
  <div class="button-container">
    <ion-button fill="outline" class="cancel-btn" (click)="cancel()" expand="block">
      {{'cancel' | translate}}
    </ion-button>
    <ion-button class="next-btn" (click)="validate()" expand="block">
      {{'apply_filter' |translate}}
    </ion-button>
  </div>
</ion-footer>